module.exports = __webpack_public_path__ + "img/9788959760305.a10716d7.jpg";